<template>
<div class="profiles">
    <fieldset class="border">
        <legend class="auto-wp" style="font-size:15px; font-weight: bold"></legend>
    
        <div class="container">
            <div class="modal animated fadeIn" tabindex="-1" id="userImageModal" role="dialog" aria-hidden="true" data-backdrop="static">
                <div class="modal-dialog modal-sm" style="top: 40%;">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="modal-fluid">
                                <div class="row">
                                    <div class="col-md-12">
                                        <center>
                                            <img src="static/assets/images/ajax-loader.gif" /> uploading, please wait..
                                        </center>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-lg-8 order-lg-2">
                    <div class="profile-head">
                        <div class='profileLoad'>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                        </div>
                        <h5>
                            <b>{{profile.fullname}}</b>
                        </h5>
                        <h6>&nbsp;&nbsp;&nbsp;&nbsp;{{myRole.role}}</h6>
                        <br />
                    </div>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a href data-target="#profile" data-toggle="tab" class="nav-link active">Profile</a>
                        </li>
    
                        <li class="nav-item">
                            <a href data-target="#edit" data-toggle="tab" class="nav-link">credentials</a>
                        </li>
                    </ul>
                    <div class="tab-content py-4">
                        <div class="tab-pane active" id="profile">
                           
                            <div class="row">
                                <div class="col-md-12">
                                    <form role="form" @submit.prevent="updateProfile()">
                                        <input type="hidden" class="id" :value="profile.id" />
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">Fullnames</label>
                                            <div class="col-lg-9">
                                                <input class="form-control fullnames" type="text" :value="profile.fullname" required/>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">Profile name</label>
                                            <div class="col-lg-9">
                                                <input class="form-control profilename" type="text" :value="profile.profilename" required/>
                                            </div>
                                        </div>
    
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">gender</label>
                                            <div class="col-lg-9">
                                                <select name="gender" class="form-control gender" :value="profile.gender" required>
                                                    <option value>select gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">Account status</label>
                                            <div class="col-lg-9">
                                                <select name='accountstatus' :value="profile.Account_status" class="form-control accontstatus" required>
                                                        {{ User.Account_status === 0 ?
                                                        <option value="0">Pending</option>: 
                                                        User.Account_status === 1 ?
                                                        <option value="1">Active</option> :
                                                        User.Account_status === 2 ? 
                                                        <option value="2">Disabled</option> :
                                                        User.Account_status === 3 ?
                                                        <option value="3">inActive</option> : ''}}
                                                    </select>
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">Email</label>
                                            <div class="col-lg-9">
                                                <input class="form-control email" type="email" :value="profile.email" required/>
                                            </div>
                                        </div>
    
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label">Password</label>
                                            <div class="col-lg-9">
                                                <input class="form-control password" type="password" placeholder="change password" />
                                            </div>
                                        </div>
    
                                        <div class="form-group row">
                                            <label class="col-lg-3 col-form-label form-control-label"></label>
                                            <div class="col-lg-9">
                                                <button type="submit" class="btn btn-primary btn-flat updatingUser">
                                                    <i class="fa fa-refresh"></i> update profile
                                                    </button>
                                                <button type="button" class="btn btn-info btn-flat updatingUserLoader">
                                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                                                    </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!--/row-->
                        </div>
    
                        <div class="tab-pane" id="edit">Add anything here</div>
                    </div>
                </div>
                <div class="col-lg-4 order-lg-1 text-center">
                    <div class="text-center">

                        <img :src="profile.profile_img === 'N/A' ? 'static/assets/images/avatar_2x.png' :  profile.profile_img !== undefined ? `http://localhost:8000/assets/images/${profile.profile_img}` : ''" class="avatar img-circle img-thumbnail" alt="avatar" />
                       
                        <div class="upload-btn-wrapper uploadIcons" v-if="profile.profile_img === 'N/A'">
                            <i class="fa fa-cloud-upload uploadIcon"></i>
                            <input type="file" name="myfile" class="text-center center-block file-upload" />
                        </div>
                        <div class="upload-btn-wrapper uploadIcons" v-else>
                            <i class="fa fa-refresh uploadIcon"></i>
                            <input type="file" name="myfile" class="text-center center-block file-upload" />
                        </div>
                        <div class="upload-btn-wrapper updateImgBtn" >
                            <i class="fa fa-upload uploadIcon uploadBtn" @click="updateUserImage()" ></i>                           
                        </div>
                    </div>
                    <hr />
                    <div class="panel panel-default">
                        <div class="panel-heading">Social Media</div>
                        <div class="panel-body">
                            <i class="fa fa-facebook fa-2x"></i>
                            <i class="fa fa-github fa-2x"></i>
                            <i class="fa fa-twitter fa-2x"></i>
                            <i class="fa fa-pinterest fa-2x"></i>
                            <i class="fa fa-google-plus fa-2x"></i>
                        </div>
                    </div>
                    <ul class="list-group">
                        <li class="list-group-item text-muted" >
                            Activity
                            <i  class="fa fa-dashboard fa-1x"></i>
                        </li>
                        <li class="list-group-item text-right">
                            <span class="pull-left">
                        <strong>Account status</strong>
                      </span> 
                         <div v-if = "profile.Account_status === 1"><i class="fa fa-check" style="color:green;"> Active</i></div>
                        </li>
                        <li class="list-group-item text-right">
                            <span class="pull-left">
                        <strong>status</strong>
                      </span> <i class="fa fa-user" style="color:green;"> {{myRole.role}}</i>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </fieldset>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    created() {
        this.LoadProfile();
    },
    computed: mapGetters(["profile", "myRole"]),
    methods: mapActions(["LoadProfile", "updateProfile", "updateUserImage"])
};
$(document).ready(function() {
    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function(e) {
                $(".avatar").attr("src", e.target.result);
               
                $('.uploadBtn').show()
                $('.uploadIcons').hide()
                localStorage.setItem('img', e.target.result)
            };
            reader.readAsDataURL(input.files[0]);
        }
    };

    $(".file-upload").on("change", function() {
        readURL(this);
    });
});
</script>

<style scoped>
.avatar {
    width: 192px;
    height: 192px;
}

.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
}

.uploadIcon {
    border: 2px solid gray;
    color: gray;
    background-color: white;
    padding: 1px 1px;
    border-radius: 8px;
    font-size: 20px;
    font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}
.uploadBtn{
    display: none
}

.updatingUserLoader {
    display: none;
}
.profiles{margin-top: -30px;}
</style>



// WEBPACK FOOTER //
// src/profile/userprofile.vue